import { DAY_KEYS, type DayKey } from "@/lib/days";
import type { WorkoutLogConfig, WorkoutLogDayData } from "@/lib/schema";
import { planningAwardDay } from "./plan";

type Runtime = { week: unknown; days: Record<DayKey, unknown> };

/** The Økter part on one day: every logged workout scores. */
function workoutPoints(config: WorkoutLogConfig, dayData: unknown): number {
  const data = (dayData ?? { workouts: [] }) as WorkoutLogDayData;
  return data.workouts.length * config.points;
}

/** The Planlegging part on one day: all of it on the save day, or nothing. */
function planningPoints(
  config: WorkoutLogConfig,
  dayKey: DayKey,
  weekData: unknown,
): number {
  if (!config.planning) return 0;
  return planningAwardDay(config, weekData) === dayKey
    ? config.planning.points
    : 0;
}

export function scoreDay(
  config: WorkoutLogConfig,
  dayData: unknown,
  dayKey: DayKey,
  weekData: unknown,
): number {
  return (
    workoutPoints(config, dayData) + planningPoints(config, dayKey, weekData)
  );
}

export function scoreWeekWorkouts(
  config: WorkoutLogConfig,
  runtime: Runtime,
): number {
  let total = 0;
  for (const k of DAY_KEYS) total += workoutPoints(config, runtime.days[k]);
  return total;
}

export function scoreWeekPlanning(
  config: WorkoutLogConfig,
  runtime: Runtime,
): number {
  let total = 0;
  for (const k of DAY_KEYS) total += planningPoints(config, k, runtime.week);
  return total;
}

export function scoreWeek(config: WorkoutLogConfig, runtime: Runtime): number {
  return (
    scoreWeekWorkouts(config, runtime) + scoreWeekPlanning(config, runtime)
  );
}

// Every logged workout scores, so a week has no ceiling (docs/adr/0003).
export function maxScoreWeek(): number {
  return Number.POSITIVE_INFINITY;
}

/** The Økter part's goal: the whole goal unless planning has split it off. */
export function workoutsWeekGoal(config: WorkoutLogConfig): number {
  if (!config.planning) return config.weekGoal;
  return config.workoutsWeekGoal ?? config.weekGoal;
}
